import React from 'react';
import { Link } from 'react-router-dom';
import { LuMap } from 'react-icons/lu';
import Page from '../../components/ui/Page/Page';
import Card from '../../components/ui/Card/Card';
import EmptyState from '../../components/ui/EmptyState/EmptyState';
import Button from '../../components/ui/Button/Button';

function NotFoundPage() {
  return (
    <Page>
      <Card>
        <EmptyState
          icon={<LuMap />}
          title="This page doesn't exist"
          description="Check the URL or head back to your dashboard."
          action={<Button as={Link} to="/">Go home</Button>}
        />
      </Card>
    </Page>
  );
}

export default NotFoundPage;
